import { AuctionItemDto } from './auction-item-dto.model';
import { AuctionImageModel } from './auction-image.model';
import { AuctionItemViewModel } from './auction-item-view.model';
import { AuctionStatus } from './auction-status';

export class AuctionItem extends AuctionItemDto {
  Images: AuctionImageModel[];
  /**
   * The current points value of the top bid. Will be set to the starting value if no bids yet.
   * This is always the same value as the AuctionItem property's property of the same name so either can be used.
   */
  CurrentValue: number;
  TimeRemainingInSeconds: number;
  RequireRefesh: number;
  RefreshRate: number;
  IsWinning: number;
  HasPreviousSuccessfulBid: boolean;
  Status: AuctionStatus;
  HasUserBidOnAuction: boolean;

  static [Symbol.hasInstance](instance: any): instance is AuctionItem {
    return 'AllowSelfBid' in instance && typeof instance.AllowSelfBid === 'boolean';
  }
}

export function flattenToAuction(auctionView: AuctionItemViewModel): AuctionItem {
  if (!auctionView) {
    return auctionView;
  }

  let auction = auctionView.AuctionItem as AuctionItem;
  auction.Images = auctionView.Images;
  auction.CurrentValue = auctionView.CurrentValue;
  auction.TimeRemainingInSeconds = auctionView.TimeRemainingInSeconds;
  auction.RequireRefesh = auctionView.RequireRefesh;
  auction.RefreshRate = auctionView.RefreshRate;
  auction.IsWinning = auctionView.IsWinning;
  auction.HasPreviousSuccessfulBid = auctionView.HasPreviousSuccessfulBid;
  auction.HasUserBidOnAuction = auctionView.HasUserBidOnAuction;

  if (auction.BidsCount === 0) {
    auction.Status = AuctionStatus.NoBids;
  } else if (auction.HasUserBidOnAuction === false) {
    auction.Status = AuctionStatus.UserNotBid;
  } else if (auction.HasPreviousSuccessfulBid) {
    if (auction.IsWinning) {
      auction.Status = AuctionStatus.UserWinning;
    } else {
      auction.Status = AuctionStatus.UserLosing;
    }
  }

  return auction;
}

export const AUCTION_TEXT_COLOR = {
  BLACK: 'text-rewards-black',
  RED: 'text-rewards-danger',
  GREEN: 'text-rewards-success',
  NEW: 'text-rewards-new',
};

export const AUCTION_STATE = {
  FEATURED: 'auction.featured.stock',
  NEW: 'auction.new.stock',
  NOT_ENOUGH_POINT: 'auction.not.enough.points',
  COMING_SOON: 'auction.coming.soon',
};
